import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    '& > *': {
      margin: theme.spacing(2)
    },
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    width: '100vw',
    overflow: 'auto',
  },
  dfb: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(4)
  },
  dfe: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: 0,
    padding: 0
  },
  errMsg: {
    color: 'red',
    marginTop: theme.spacing(2),
  },
  successMsg: {
    color: 'green',
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: '75%'
  },
  ml2: {
    marginLeft: theme.spacing(2),
  },
  mt2: {
    marginTop: theme.spacing(2),
  },
  fileUpload: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#e3e8ea',
    height: '30vh',
    border: '2px dashed gray',
    cursor: 'pointer'
  },
  pFormControl: {
    margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
    width: '100%',
  },
  lt: {
    fontSize: '2rem'
  },
  dNone: {
    display: "none"
  }
});
